/**
 * Two-step sign-in: after the password, a code from an authenticator app
 * (or a one-time recovery code). Turning it on or off, and making new
 * recovery codes, needs the current password's auth key.
 */
import { afterLogout, post, request } from '~/util/hubClient';
/** Completes a sign-in with an authenticator or recovery code. */
export async function completeSignIn(token, code) {
    await afterLogout();
    return request('/v1/admin/auth/second-factor', post({ token, code }));
}
export async function secondFactorStatus() {
    return request('/v1/admin/account/second-factor');
}
export async function startTotp(authKey) {
    return request('/v1/admin/account/second-factor/totp', post({ auth_key: authKey }));
}
/** Turns the new authenticator on. Returns recovery codes the first time. */
export async function confirmTotp(code) {
    const reply = await request('/v1/admin/account/second-factor/totp/confirm', post({ code }));
    return reply.recovery_codes;
}
export async function disableSecondFactor(authKey) {
    await request('/v1/admin/account/second-factor/disable', post({ auth_key: authKey }));
}
export async function newRecoveryCodes(authKey) {
    const reply = await request('/v1/admin/account/second-factor/recovery-codes', post({ auth_key: authKey }));
    return reply.recovery_codes;
}
/** An SVG document as an image source, so it's shown without being
 * inserted into the page as markup. */
export function svgDataUrl(svg) {
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}
/** Recovery codes as a text file to save or print. */
export function recoveryCodesText(email, codes) {
    return [
        `Zunox recovery codes for ${email}`,
        'Each code signs you in once, in place of an authenticator code.',
        'Keep them somewhere safe, apart from your phone.',
        '',
        ...codes,
        '',
    ].join('\n');
}
